import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalClose: {
    top: '24px',
    right: '24px'
  },

  mobileChildren: {
    height: '100svh',
    maxHeight: '100%'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    paddingTop: '6px'
  },

  mobileRoot: {
    marginTop: '0',
    paddingTop: '0'
  },

  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 22px 0',

    '& > span': {
      fontSize: theme.size.lg,
      color: '#1F1F1F'
    }
  },

  mobileBackArrow: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  textField: {
    marginBottom: '0.5rem',

    '& input:focus': {
      borderColor: theme.palette.textfield.border,
      boxShadow: 'none'
    }
  },

  infoMessage: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',

    '& .more': {
      marginLeft: '0.25rem',
      cursor: 'pointer',
      textDecoration: 'underline',
      color: theme.palette.primary.main,
      userSelect: 'none'
    },

    '& .load': {
      marginLeft: '0.25rem',
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
      userSelect: 'none'
    }
  },

  messageHolder: {
    overflow: 'hidden auto',
    border: '1px solid rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    boxSizing: 'border-box',
    boxShadow: '1px 1px 1px 0px rgba(0, 0, 0, 0.15)',
    paddingTop: '4px'
  },

  noResults: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    textAlign: 'center',
    color: theme.palette.textLight
  },

  buttonArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '96px',
    paddingTop: 12,

    '& > :first-child': {
      marginRight: '16px'
    }
  },

  buttonAreaMobile: {
    justifyContent: 'center',
    bottom: '68px',
    left: '0',
    right: '0',
    margin: '0',
    height: 'auto',
    padding: '12px 24px',

    '& button': {
      flex: '1',
      maxWidth: '200px'
    }
  },

  button: {
    height: '48px'
  },

  goto: {
    margin: '0.5rem',
    height: 'fit-content',
    cursor: 'pointer'
  }
}))

export default useStyles
